export default __webpack_public_path__ + "static/media/advice-icon.1f1deebb.png";